<!--
<button *ngIf="!isMyProfile" mat-button matTooltip="Back To User Search Page" class="user-profile-back-to-search" (click)="backToSearchResults()">
  <mat-icon>arrow_back</mat-icon>
  <span>Back</span>
</button>
-->

<!-- <p *ngIf="isMobile">This is mobile?</p> -->

<div class="user-profile-container" [ngClass]="{'user-profile-container-loading': loading}">
  @if (!loading) {
    <section class="user-profile-description-container">
      <div
           [ngClass]="userInfo.todayInOfice=='O' ? 'user-profile-photo-container-office' :  (userInfo.todayInOfice =='N' ? 
           'user-profile-photo-container-offline' : 'user-profile-photo-container-tele')">
        @if (userInfo.photoSafe) {
          <img class="user-profile-photo"
            [src]="userInfo.photoSafe"
            alt="User Photo">
        } @else {
          <img src="assets/images/logo_and_icons/empty_portrait_white_large.png"  class="user-profile-photo" alt="Empty Picture">
        }
        @if (isMyProfile || isAdmin || isDeveloper) {
          <button id="user-profile-photo-edit-btn" mat-icon-button matTooltip="Edit Picture" (click)="onEditingUserProfilePhoto()">
            <mat-icon color="accent">add_a_photo</mat-icon>
          </button>
        }
        @if (userInfo.todayInOfice=='O') {
          <mat-icon
            aria-label="In Office"
            matTooltip="In Office"
            class="user-profile-photo-icon-office"
            >
            location_city
          </mat-icon>
          } @if (userInfo.todayInOfice=='T') {
          <mat-icon
            aria-label="Telework"
            matTooltip="Telework"
            class="user-profile-photo-icon-tele"
            >
            home
          </mat-icon>
          } @if (userInfo.todayInOfice=='N') {
          <mat-icon
            aria-label="Offline"
            matTooltip="Non-Duty Days/Offline"
            class="user-profile-photo-icon-offline"
            >
            clear
          </mat-icon>
        }
      </div>
      <div class="user-profile-job-description-container">
        <span class="user-profile-name">
          {{userInfo.name}}   @if (isDeveloper) {
          <span id="infoActiveUserInput"> &nbsp;({{profileEmployeeId }})</span>
        }
      </span>
      <span class="user-profile-user-job">{{userInfo.jobTitle}}</span>
      <span class="user-profile-user-job">@if (isMyProfile) {
        <a class="colorwhite" matTooltip="Divison's Employee Office Status Report" [routerLink]="['/teleworkreports']"> {{userInfo.division}} </a>
        } @if (!isMyProfile) {
        <label> {{userInfo.division}}  </label>
        }  @if (userSectionExists) {
        <div style="display: inline;" > - {{userInfo.section}}</div>
      }</span>
      <span class="user-profile-user-job">{{userInfo.companyName}}</span>
      @if (isAdmin || isDeveloper) {
        <span id="infoActiveUserInput"></span>
      }
    </div>
  </section>
}
@if (!loading) {
  <section class="user-profile-info-container">
    <div class="user-profile-contact-info-container">
      <div style="display: inline;">
        <div style="text-align: right; padding-right: 10px; color:blue; cursor: pointer;">  @if (isMyProfile || isAdmin || isDeveloper) {
          <button matTooltip="Edit Profile" mat-icon-button (click)="onEditUserProfile()">
            <mat-icon style="text-align: right; text-decoration: underline; color: black;display: inline;" color="accent" >edit</mat-icon>
          </button>
        }</div>
        @if (isAdmin || isDeveloper || isMyProfile) {
          <div  style="text-align: left; margin-top: -45px;">
            <h2>Contact Information</h2>
          </div>
        }
        @if (!isAdmin && !isDeveloper && !isMyProfile) {
          <div  style="text-align: left;">
            <h2 >Contact Information</h2>
          </div>
        }
      </div>
      <div class="line"> <hr> </div>
      <div class="user-profile-contact-info-section">
        <div class="user-profile-main-contact-info-container">
          <span class="user-profile-contact-info-section-col">
            @if (userInfo.email) {
              <span class="user-profile-contact">
                <mat-icon matTooltip="Email" class="user-profile-contact-icon" color="primary">email</mat-icon>
                <a href="mailto:{{userInfo.email}}">{{userInfo.email}}</a>
              </span>
            }
            <div class="user-profile-contact-number-container">
              <span class="user-profile-contact-info-section-col-secondary">
                @for (device of userInfo.lsdt; track device) {
                  <span class="user-profile-contact">
                    @if (device.visible) {
                      @if ((device.type == 'Business Cell Phone' || device.type == 'Personal Cell Phone')) {
                        <mat-icon matTooltip="Contacts" class="user-profile-contact-icon" color="primary">smartphone</mat-icon>
                      } @else {
                        <mat-icon class="user-profile-contact-icon" color="primary">local_phone</mat-icon>
                      }
                      @if (device.preferred) {
                        <a href="tel:{{device.number}}"><strong>{{device.number | phone}}</strong></a>
                      }
                      @if (!device.preferred) {
                        <a href="tel:{{device.number}}"><span>{{device.number | phone}}</span></a>
                      }
                      <!-- <mat-icon *ngIf="device.preferred" class="user-profile-contact-icon" color="primary" matTooltip="Preferred Contact">priority_high</mat-icon> -->
                    }
                  </span>
                }
              </span>
            </div>
            @if (userInfo.callSign) {
              <span class="user-profile-contact">
                <mat-icon matTooltip="Call Sign" class="user-profile-contact-icon" color="primary">badge</mat-icon>
                {{userInfo.callSign}}
              </span>
            }
            @if (userInfo.workTimeAndSummary) {
              <span class="user-profile-contact">
                <mat-icon matTooltip="Work Time"  class="user-profile-contact-icon" color="accent">schedule</mat-icon>
                {{userInfo.workTimeAndSummary}}
              </span>
            }
            <div class="workweek-grid" >
              <!-- Row 1: Day Labels -->
              <div class="grid-row">
                <div class="cell">
                  <mat-icon matTooltip="Working Day" class="user-profile-contact-icon topdow"  color="primary">
                    date_range
                  </mat-icon>
                </div>
                <div class="cell">
                  <label class="user-profile-workday-firstday"
                    [ngClass]="{'user-profile-workday-active': userInfo.workTime.mon}">
                    Mon
                  </label>
                </div>
                <div class="cell">
                  <label class="user-profile-workday"
                    [ngClass]="{'user-profile-workday-active': userInfo.workTime.tue}">
                    Tue
                  </label>
                </div>
                <div class="cell">
                  <label class="user-profile-workday"
                    [ngClass]="{'user-profile-workday-active': userInfo.workTime.wed}">
                    Wed
                  </label>
                </div>
                <div class="cell">
                  <label class="user-profile-workday"
                    [ngClass]="{'user-profile-workday-active': userInfo.workTime.thu}">
                    Thu
                  </label>
                </div>
                <div class="cell">
                  <label class="user-profile-workday"
                    [ngClass]="{'user-profile-workday-active': userInfo.workTime.fri}">
                    Fri
                  </label>
                </div>
                <div class="cell">
                  <label class="user-profile-workday"
                    [ngClass]="{'user-profile-workday-active': userInfo.workTime.sat}">
                    Sat
                  </label>
                </div>
                <div class="cell">
                  <label class="user-profile-workday"
                    [ngClass]="{'user-profile-workday-active': userInfo.workTime.sun}">
                    Sun
                  </label>
                </div>
              </div>
              @if (userInfo.hasTelework==true) {
                <div class="grid-row">
                  <!-- Blank cell under the Working Day icon -->
                  <div class="cell">
                    <mat-icon matTooltip="Pay Week" class="user-profile-contact-icon" color="accent">payments</mat-icon>
                  </div>
                  <!-- Monday -->
                  <div class="cell">
                    @if (userInfo.workTime.mon && isOfficeDay('Mon')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon leftmore"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.mon && isTelework('Mon')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon leftmore"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Tuesday -->
                  <div class="cell">
                    @if (userInfo.workTime.tue && isOfficeDay('Tue')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.tue && isTelework('Tue')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Wednesday -->
                  <div class="cell">
                    @if (userInfo.workTime.wed && isOfficeDay('Wed')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.wed && isTelework('Wed')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Thursday -->
                  <div class="cell">
                    @if (userInfo.workTime.thu && isOfficeDay('Thu')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.thu && isTelework('Thu')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Friday -->
                  <div class="cell">
                    @if (userInfo.workTime.fri && isOfficeDay('Fri')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.fri && isTelework('Fri')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Saturday -->
                  <div class="cell">
                    @if (userInfo.workTime.sat && isOfficeDay('Sat')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.sat && isTelework('Sat')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Sunday -->
                  <div class="cell">
                    @if (userInfo.workTime.sun && isOfficeDay('Sun')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.sun && isTelework('Sun')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                </div>
              }
              @if (userInfo.hasTelework==true) {
                <div class="grid-row">
                  <!-- Blank cell under the Working Day icon -->
                  <div class="cell">
                    <mat-icon matTooltip="Non Pay Week" class="user-profile-contact-icon" color="accent" >block</mat-icon>
                  </div>
                  <!-- Monday -->
                  <div class="cell">
                    @if (userInfo.workTime.mon && isnonPayOffice('Mon')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon leftmore"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.mon && isnonPayTelework('Mon')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon leftmore"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Tuesday -->
                  <div class="cell">
                    @if (userInfo.workTime.tue && isnonPayOffice('Tue')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.tue && isnonPayTelework('Tue')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Wednesday -->
                  <div class="cell">
                    @if (userInfo.workTime.wed && isnonPayOffice('Wed')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.wed && isnonPayTelework('Wed')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Thursday -->
                  <div class="cell">
                    @if (userInfo.workTime.thu && isnonPayOffice('Thu')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.thu && isnonPayTelework('Thu')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Friday -->
                  <div class="cell">
                    @if (userInfo.workTime.fri && isnonPayOffice('Fri')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.fri && isnonPayTelework('Fri')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Saturday -->
                  <div class="cell">
                    @if (userInfo.workTime.sat && isnonPayOffice('Sat')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.sat && isnonPayTelework('Sat')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                  <!-- Sunday -->
                  <div class="cell">
                    @if (userInfo.workTime.sun && isnonPayOffice('Sun')) {
                      <mat-icon
                        class="telework_section-icon telework_office-icon"
                        matTooltip="In Office">
                        location_city
                      </mat-icon>
                    }
                    @if (userInfo.workTime.sun && isnonPayTelework('Sun')) {
                      <mat-icon
                        class="telework_section-icon telework_telework-icon"
                        matTooltip="Telework">
                        home
                      </mat-icon>
                    }
                  </div>
                </div>
              }
            </div>
          </span>
        </div>
        <div class="user-profile-add-contact-info-container">
          @if (userInfo.qRCode) {
            <span class="user-profile-contact-info-section-col-ternary">
              <span>
                <img class="qrCode" src="{{userInfo.qRCode}}" alt="QR Code" />
                <p></p>
              </span>
              <span><b>Scan Me</b></span>
            </span>
          }
          <div #add_to_contacts class="user-profile-contact-info-section-col-ternary_add_to_contacts" (click)="onAddToContacts()">
            <span>
              <img src="assets/images/logo_and_icons/AddToContacts.png">
            </span>
            <span style="text-align:center; margin-left: 1rem;"><b>Click to add to Contacts</b></span>
          </div>
        </div>
      </div>
    </div>
    <!-- <section class="user-profile-team"> -->
    @if (userInfo.supervisor) {
      <div class="user-profile-supervisor-info-container" style="text-align: left;">
        <h2 id="h2Header">Supervisor</h2>
        <div class="line"> <hr> </div>
        <div class="user-profile-supervisor" (click)="onUserInProfileSelect(userInfo.supervisor.id!)">
          <div>
            @if (userInfo.supervisor.todayInOfice=='O') {
              <mat-icon
                aria-label="In Office"
                matTooltip="In Office"
                class="hang-left-icon-office-sup"
                >
                location_city
              </mat-icon>
            }
            @if (userInfo.supervisor.todayInOfice=='T') {
              <mat-icon
                aria-label="On Telework"
                matTooltip="On Telework"
                class="hang-left-icon-home-sup"
                >
                home
              </mat-icon>
            }
            @if (userInfo.supervisor.todayInOfice=='N') {
              <mat-icon
                aria-label="Offline"
                matTooltip="Non-Duty Days/Offline"
                class="hang-left-icon-home-offline-sup"
                >
                clear
              </mat-icon>
            }
          </div>
          <span  [ngClass]="userInfo.supervisor.todayInOfice =='O' ? 'user-profile-generic-photo-container-office' :  userInfo.supervisor.todayInOfice =='N' ? 'user-profile-generic-photo-container-offline' : 'user-profile-generic-photo-container'">
            @if (userInfo.supervisor.photoSafe) {
              <img
                class="user-profile-photo"
                [src]="userInfo.supervisor.photoSafe"
                alt="User Photo">
            } @else {
              <img src="assets/images/logo_and_icons/empty_portrait_white_large.png"  class="user-profile-photo" alt="Empty Picture">
            }
          </span>
          <span class="user-profile-generic-name">{{userInfo.supervisor.name}}</span>
          <span>{{userInfo.supervisor.jobTitle}}</span>
        </div>
      </div>
    }
  </section>
}
@if (!loading && userInfo.isSupervisor) {
  <section class="user-profile-direct-reports-info-container">
    <div class="directReportLink">
      <h2  class="marginzero">Direct Reports</h2>
      @if (isMyProfile || isAdmin || isDeveloper) {
        <button id="user-profile-direct-report" mat-icon-button matTooltip="Manage Direct Report(s)" (click)="AddEmployee()">
          <mat-icon style="text-align: right; text-decoration: underline; color: black;display: inline;" color="accent" >edit</mat-icon>
        </button>
      }
    </div>
    <div class="line"><hr></div>
    <div class="user-profile-direct-report-list">
      @for (dir of userInfo.drlist; track dir) {
        <div class="user-profile-direct-report" (click)="onUserInProfileSelect(dir.id!)">
          <div>
            @if (dir?.todayInOfice=='O') {
              <mat-icon
                aria-label="In Office"
                matTooltip="In Office"
                class="hang-left-icon-office"
                >
                location_city
              </mat-icon>
            }
            @if (dir?.todayInOfice=='T') {
              <mat-icon
                aria-label="On Telework"
                matTooltip="On Telework"
                class="hang-left-icon-home"
                >
                home
              </mat-icon>
            }
            @if (dir?.todayInOfice=='N') {
              <mat-icon
                aria-label="Offline"
                matTooltip="Non-Duty Days/Offline"
                class="hang-left-icon-home-offline"
                >
                clear
              </mat-icon>
            }
          </div>
          <span  [ngClass]="dir?.todayInOfice=='O' ? 'user-profile-generic-photo-container-office' : dir?.todayInOfice=='N' ? 'user-profile-generic-photo-container-offline' :'user-profile-generic-photo-container'" class="user-profile-generic-photo-container">
            @if (dir?.photoSafe) {
              <img
                class="user-profile-photo"
                [src]="dir.photoSafe"
                alt="User Photo"
                >
            } @else {
              <img src="assets/images/logo_and_icons/empty_portrait_white_large.png"  class="user-profile-photo" alt="Empty Picture">
            }
          </span>
          <!-- <div class="user-profile-direct-report-details"> -->
          <span class="user-profile-generic-name">{{dir.name}}</span>
          <span class="user-profile-generic-title">{{dir.jobTitle}}</span>
        <!-- </div> -->
      </div>
    }
  </div>
</section>
}
@if (loading) {
  <mat-spinner color="accent"></mat-spinner>
}
</div>
<!-- <app-edit-user-profile *ngIf="editingMyProfile"></app-edit-user-profile> -->
